/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppSendSkipReasonSchema = z.enum(['no_phone', 'opted_out', 'missing_parameter_data'])

export type WhatsAppSendSkipReasonSchema = z.infer<typeof whatsAppSendSkipReasonSchema>
